const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjecteIdAlumneIdAvaluacio = async ( id_projecte : string, id_usuari : string, modul : string, ra : string, avaluacio : number, observacions: string = "", id_recuperacio?: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/alumnes/${id_usuari}/validacio`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body:  JSON.stringify( {
                modul : modul,
                ra : ra,
                avaluacio : avaluacio,
                observacions : observacions,
                idRecuperacio : id_recuperacio
            })
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
